// Thin wrappers around the /notifications endpoints used by the bell
// icon in the app header.
import { get, post } from '../index';

export const listNotifications = ({ scope = 'mine', status = null, limit = 50 } = {}) => {
  const qs = new URLSearchParams();
  qs.set('scope', scope);
  if (status) qs.set('status', status);
  if (limit) qs.set('limit', String(limit));
  return get(`/notifications?${qs.toString()}`);
};

export const unreadNotificationCount = ({ scope = 'mine' } = {}) =>
  get(`/notifications/unread-count?scope=${encodeURIComponent(scope)}`);

export const markNotificationRead = (id) => post(`/notifications/${id}/read`, {});

// Tell the backend the given rows have been surfaced in the panel so
// they stop counting toward the unread badge. `ids` is the list of
// notification ids currently on screen.
export const markNotificationsViewed = (ids) => post('/notifications/mark-viewed', { ids });

export const markAllNotificationsRead = () => post('/notifications/read-all', {});

export const dismissNotification = (id) => post(`/notifications/${id}/dismiss`, {});
